<template>
	<div class="v3-banner" ref="bannerRef">
		<p class="v3-banner__text">
			<span class="v3-banner__badge">Nouveau</span>
			Découvrez Semactic v3, la version la plus avancée jamais proposée par Semactic, enrichie régulièrement de nouvelles fonctionnalités.
		</p>
		<a class="v3-banner__cta" :href="app3Url" target="_blank" rel="noopener">
			Passer à la v3 →
		</a>
	</div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useMarketStore } from '@/store/global/market';

const bannerRef = ref(null);
const marketStore = useMarketStore();
const { selectedProject, selectedMarket } = storeToRefs(marketStore);

const app3Url = computed(() => {
	const url = new URL('https://app3.semactic.com');
	if (selectedProject.value && selectedProject.value !== 'na') {
		url.searchParams.set('project_id', selectedProject.value);
	}
	if (selectedMarket.value) {
		url.searchParams.set('market_id', selectedMarket.value);
	}
	return url.toString();
});

function updateBannerHeight() {
	if (bannerRef.value) {
		document.documentElement.style.setProperty('--v3-banner-height', `${bannerRef.value.offsetHeight}px`);
	}
}

onMounted(() => {
	updateBannerHeight();
	window.addEventListener('resize', updateBannerHeight);
});

onUnmounted(() => {
	window.removeEventListener('resize', updateBannerHeight);
	document.documentElement.style.removeProperty('--v3-banner-height');
});
</script>

<style lang="scss" scoped>
.v3-banner {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 1rem;
	width: 100%;
	padding: 0.6rem 1.5rem;
	background-color: var(--bleu-500);
	color: var(--blanc);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	&__text {
		margin: 0;
		text-align: center;
		font-size: 14px;
		line-height: 1.4;
	}

	&__badge {
		display: inline-block;
		margin-right: 0.5rem;
		padding: 0.1rem 0.5rem;
		border-radius: 999px;
		background-color: var(--jaune-500);
		color: var(--noir);
		font-size: 12px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.02em;
	}

	&__cta {
		flex-shrink: 0;
		display: inline-block;
		padding: 0.4rem 1.1rem;
		border-radius: 8px;
		background-color: var(--jaune-500);
		color: var(--noir);
		font-weight: 700;
		font-size: 14px;
		text-decoration: none;
		white-space: nowrap;
		transition: background-color 0.2s;

		&:hover {
			background-color: var(--jaune-600);
		}
	}
}

@media (max-width: 768px) {
	.v3-banner {
		justify-content: flex-start;
		padding: 1rem;

		&__text {
			text-align: left;
		}

		&__cta {
			width: 100%;
			text-align: center;
		}
	}
}
</style>
